export const mobileTitleRule = (columnId, label) => (
  `td.${columnId}:before { content: "${label}"; }`
);

export default { mobileTitleRule };
